import { React, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Box,
  Paper,
  useMediaQuery
} from '@material-ui/core';
import { ROUTES } from '../../../../constants/routes';
import { useHistory } from 'react-router-dom'
import { motion } from "framer-motion/dist/es/index";
// import coverImage from 'https://www.musicminduat.dk/media/artist_covers/Kontakt/cover.JPG';

export default function SectionTwo(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  const isMobileSmall = useMediaQuery(theme.breakpoints.up('md'));
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Raleway',
    },
    sectionOne: {
      backgroundColor: 'white',
      // paddingLeft: 20,
      // paddingRight: 20,
      fontSize: '1.2rem',
      color: 'black',
      height: '400px'
    },
    sectionOneMobile: {
      backgroundColor: 'white',
      fontSize: '.9rem',
      color: 'black',
      height: '400px'

    },
    innerGridContainer: {
      width: "100%",
      margin: "0px",
      padding: "30px"
    },
    innerGridSmallHeading: {
      width: "100%",
      textAlign: "left",
      fontSize: "1rem",
      fontWeight: "bold"
    },
    innerGridHeading: {
      width: "100%",
      textAlign: "left",
      fontSize: "3rem",
      fontFamily: "sans-serif"
    },
    sectionParagraph: {
      // margin: "10px 0px",
      textAlign: "left",
      fontSize: ".6rem",
      marginTop: '-30px',
      fontWeight: 'bold'
    },
    media: {
      maxHeight: 300,
      maxWidth: 700,
      minHeight: 300,
      float: 'right',
      width: '100%'
    },
  }));

  const classes = useStyles();
  const history = useHistory();
  const text1 = 'Lever lyden op til '
  const text2 = ' dit '
  const text3 = ' brand? '
  const sentence = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        delay: 1,
        staggerChildren: 0.2,
      },
    },
  }

  const letter = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
    }
  }

  return (
    <div className={classes.root}>
      <section className={isMobile ? classes.sectionOne : classes.sectionOneMobile}>
        <Grid container>
          <img src={'https://www.musicminduat.dk/media/artist_covers/Kontakt/cover.JPG'} height={'450'} width={'100%'}/>
        </Grid>
      </section >
    </div >
  )
}